<template>
  <div class="w-full bg-white">
    <div class="hidden md:block w-full border-b border-black border-opacity-10">
      <div class="flex w-full max-w-content-sm mx-auto">
        <label
          class="hidden md:block w-1/2 p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="countries-select"
        >
          Country
        </label>
        <label
          class="hidden md:block w-1/2 p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="adventure-types-select"
        >
          Type
        </label>
        <label
          class="hidden md:block w-1/2 p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="adventure-month-select"
        >
          Month
        </label>
      </div>
    </div>
    <div class="w-full max-w-content-sm mx-auto md:flex">
      <div class="w-full md:w-1/2">
        <label
          class="block md:hidden w-full p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="countries-select"
          >Country</label
        >
        <div class="select-wrapper relative text-blue-dark">
          <select
            name="countries"
            id="countries-select"
            class="h-12.5 w-full pl-5 shadow-tandb md:shadow-left bg-white font-primary font-extrabold text-blue-brand text-16 uppercase tracking-1/4"
            v-model="country"
            @change="onChange"
            :disabled="loadingCountries"
          >
            <option :value="null">All</option>
            <option v-for="(item, index) in countries" :key="index" :value="item.slug">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="w-full md:w-1/2">
        <label
          class="block md:hidden w-full p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="adventure-types-select"
          >Type</label
        >
        <div class="select-wrapper relative text-blue-dark">
          <select
            name="adventure-types"
            id="adventure-types-select"
            class="h-12.5 w-full pl-5 shadow-tandb md:shadow-landr bg-white font-primary font-extrabold text-blue-brand text-16 uppercase tracking-1/4"
            v-model="adventureType"
            @change="onChange"
            :disabled="loadingAdventureTypes"
          >
            <option :value="null">All</option>
            <option v-for="(item, index) in adventureTypes" :key="index" :value="item.slug">
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="w-full md:w-1/2">
        <label
          class="block md:hidden w-full p-2.5 bg-white font-primary font-extrabold text-14 leading-1"
          for="adventure-month-select"
          >Month</label
        >
        <div class="select-wrapper relative text-blue-dark">
          <select
            name="adventure-month"
            id="adventure-month-select"
            class="h-12.5 w-full pl-5 shadow-tandb md:shadow-landr bg-white font-primary font-extrabold text-blue-brand text-16 uppercase tracking-1/4"
            v-model="month"
            @change="onChange"
          >
            <option :value="null">All</option>
            <option :value="1">January</option>
            <option :value="2">February</option>
            <option :value="3">March</option>
            <option :value="4">April</option>
            <option :value="5">May</option>
            <option :value="6">June</option>
            <option :value="7">July</option>
            <option :value="8">August</option>
            <option :value="9">September</option>
            <option :value="10">October</option>
            <option :value="11">November</option>
            <option :value="12">December</option>
          </select>
        </div>
      </div>
    </div>
    <div class="w-full border-t border-black border-opacity-10">
      <div class="w-full max-w-content-sm mx-auto px-2.5 pt-2.5 pb-5 bg-white">
        <label
          class="flex items-center justify-between w-full bg-white font-primary font-extrabold text-14 mb-2.5"
          for="grading-range"
        >
          <span class="flex items-center">
            Activity Grading
            <grading-modal-button>
              <div slot-scope="slotProps">
                <button
                  type="button"
                  @click.prevent="slotProps.openModal()"
                  aria-label="About activity grading"
                >
                  <svg-sprite
                    href="icon-tooltip"
                    class="h-4 w-4 ml-1 inline-block cursor-pointer"
                  ></svg-sprite>
                </button>
              </div>
            </grading-modal-button>
          </span>
          <svg-sprite href="icon-hiker" class="h-5 w-3.75"></svg-sprite>
        </label>
        <div class="mb-5 lg:mb-7.5">
          <vue-slider
            v-model="grading"
            :data="gradings"
            tooltip="none"
            :marks="true"
            :duration="0.3"
            :contained="true"
            :silent="true"
            @change="onChange"
            id="grading-range"
          ></vue-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';
import VueSlider from 'vue-slider-component';
import debounce from 'lodash/debounce';
import GradingModalButton from './GradingModalButton.js';

export default {
  components: { VueSlider, SvgSprite, GradingModalButton },

  props: {
    defaultCountry: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      country: this.defaultCountry,
      countries: [],
      loadingCountries: false,
      adventureType: null,
      adventureTypes: [],
      loadingAdventureTypes: false,
      grading: [1, 9],
      gradings: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      month: null,
    };
  },

  computed: {
    gradingMin() {
      return this.grading[0];
    },

    gradingMax() {
      return this.grading[1];
    },

    searchData() {
      return {
        min_grade: this.gradingMin,
        max_grade: this.gradingMax,
        country: this.country,
        adventure_type: this.adventureType,
        month: this.month,
      };
    },
  },

  created() {
    this.getCountries();
    this.getAdventureTypes();
  },

  methods: {
    async getCountries(page = 1) {
      this.loadingCountries = true;
      this.error = null;

      await axios
        .get(Route('json.countries.index'), {
          params: {
            order_by: 'name',
            order: 'asc',
            page: page,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.countries = this.countries.concat(response.data.countries);
          } else {
            throw 'There was a problem.';
          }

          if (this.countries.length < response.data.total) {
            this.getCountries(page + 1);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.loadingCountries = false;
        });
    },

    getAdventureTypes() {
      this.loadingAdventureTypes = true;
      this.error = null;

      axios
        .get(Route('json.adventure-types.index'))
        .then((response) => {
          if (response.status === 200) {
            this.adventureTypes = response.data.adventure_types;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.loadingAdventureTypes = false;
        });
    },

    onChange: debounce(function() {
      this.$emit('search-results', this.searchData);
    }, 750),
  },

  watch: {
    country(country) {
      this.$emit('country', country);
    },
  },
};
</script>
